import { render } from "./whatsapp-icon.vue?vue&type=template&id=5faa2786"
import script from "./whatsapp-icon.vue?vue&type=script&lang=js"
export * from "./whatsapp-icon.vue?vue&type=script&lang=js"

import "./whatsapp-icon.vue?vue&type=style&index=0&id=5faa2786&lang=css"
script.render = render

export default script